const adminOptions = {
  showDeletedTitle: 'Recursos de Administración',
  showDeleted: 'Mostrar solo equipos eliminados',
  showDeletedChipLabel: 'Equipos Eliminados',
};

export default adminOptions;